'use strict';

export default function ObserverList() {
    this.list = [];
}

ObserverList.prototype.add = function (obj) {
    return this.list.push(obj);
};

ObserverList.prototype.count = function () {
    return this.list.length;
};

ObserverList.prototype.get = function (index) {
    if (index > -1 && index < this.list.length) {
        return this.list[index];
    }
};

ObserverList.prototype.indexOf = function (obj, startIndex) {
    var i = startIndex;

    while (i < this.list.length) {
        if (this.list[i] === obj) {
            return i;
        }
        i++;
    }

    return -1;
};

ObserverList.prototype.remove = function (observer) {
    this.list.removeAt(this.list.indexOf(observer, 0));
};

ObserverList.prototype.removeAt = function (index) {
    this.list.splice(index, 1);
};

ObserverList.prototype.update = function (context) {
    for (let i = 0, ln = this.list.length; i < ln; ++i) {
        this.list[i](context);
    }
};
